<template>
    <div class="container d-flex py-5 main-container ">
        <div class="my-auto w-100 main-area reg-terms-nx">
            <div class="registration-head text-center d-flex align-items-end">
                <img
                    src="./../assets/images/bloom_logo.svg"
                    alt="bloom"
                    class="logoClass"
                />
                <h1 class="rg-title">
                    Bloomキャリア登録　ユーザー利用規約　|　株式会社Bloom
                </h1>
            </div>
            <!-- ends-registration-head -->
            <div class="reg-terms-in" style="text-align: justify;">
                <!-- <p>「Bloom キャリア登録」ユーザー利用規約</p> -->
                <TermsLists/>
            </div>
            <!--ends registration-detail-area -->
        </div>
        <!-- ends main-area -->
    </div>
</template>

<script>
/* eslint-disable */
import TermsLists from './TermsLists.vue';
export default {
    name: "Agreement",
    components: { TermsLists },
    mounted() {},
};
</script>
<style scoped>
.registration-head {
    background-color: #ffff !important;
    color: gray !important;
    padding: 15px;
    /* height: 120px !important; */
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: flex-start !important;
    font-family: "Roboto", sans-serif;
    margin-left: 20px;
}

.registration-head h1 {
    color: #333333 !important;
    font-size: 25px !important;
    margin-left: 60px !important;
}

.logoClass {
    width: 25%;
}

.main-area {
    color: #333333 !important;
    box-shadow: none !important;
}
.reg-terms-nx {
    /*margin-bottom: 30px;*/
    background-color: #ffff;
    /* border: solid 1px #d9e6ed; */
    /*padding: 25px 35px 15px;*/
}
.reg-terms-in {
    margin-bottom: 30px;
    padding: 25px 35px 15px;
}

@media (max-width: 767px) {
    .registration-head {
        height: 80px !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        margin-bottom: 30px !important;
        padding-right: 35px;
        padding-left: 35px;
        margin-left: 0px !important;
    }

    .registration-head h1 {
        color: gray !important;
        font-size: 18px !important;
        margin-left: 0px !important;
        text-align: justify;
    }

    .logoClass {
        width: 70%;
    }
}
</style>
